import React, { PureComponent } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import * as HTML_RENDITION from '../utils/general/general';
import { IReducerState } from '../states/renditionStates';
import { connect } from 'react-redux';
import { checkDomEntitlement } from '../utils/general/checkDomEntitlement';
import UserAgentUtils from '../utils/general/userAgentUtils';
import { RenditionLoadable } from '../utils/general/LoadableRelated';
import { fetchCopyURL, fetchCvrCopyURL, fetchFPFigureGallery } from '../actions/asyncStateAction';
import servicesConfig from '../services/servicesConfig';
import Scrollbars from 'react-custom-scrollbars';
import { switchPage } from '../utils/api/pageControl';
import * as environmentService from '../utils/general/environmentService';
import { RSCH_HTML_TRACKING_CONFIG } from '../readership/trackingConfig';
import { getContextPath } from '../utils/general/environmentService';
import commonStore from '../store/commonStore.js';
import * as MENU_CHECK from './leftMenuRelated/menuGeneralCheck';
import {isStaticMode, getURLData} from '../utils/general/general';
import defaultImg from '../../../src/style/img/default.jpg';
import { enterKeyPressed } from '../utils/general/enterKey';
import {isCitiExpress} from '../utils/general/general';
import { isNull } from '../utils/general/stringUtils';

// Important!!! this is left Menu-Part-Template don't use old rendition DOM logic and structure. So also have some style change in overview.scss

const TOCContainer = RenditionLoadable({
    loader: () => import('./leftMenuRelated/tableOfContents'),
}, "tableOfContents", Date.now());

const TagsContainer = RenditionLoadable({
    loader: () => import('./leftMenuRelated/tags'),
}, "tags", Date.now());

const CopyURLContainer = RenditionLoadable({
    loader: () => import('./leftMenuRelated/copyURL'),
}, "copyURL", Date.now());

const PrintTabContainer = RenditionLoadable({
    loader: () => import('./leftMenuRelated/printTab'),
}, "printTab", Date.now());

const MoreContainer = RenditionLoadable({
    loader: () => import('./leftMenuRelated/moreTab'),
}, "moreTab", Date.now());

interface ILeftMenuPartTemplateProps {
    source?: any;
    docTitle: string;
    docHeaderSectionJson: any;
    initialData: any;
    copyURLData: any;
    loadCopyURLData: (s: string) => {};
    loadPublicCopyURLData: (s: string) => {};
    loadFPFigureGalleryData: () => {};
    showOldBranding: boolean;
    collapsed: boolean;
    loadCvrCopyURLData: (s: string) => {};
}

interface ILeftMenuPartTemplateStatus {
    loadBackTab: boolean;
    loadTOCPart: boolean;
    loadTags: boolean;
    loadCopyURL: boolean;
    loadPrintTab: boolean;
    loadMoreTab: boolean;
    isSmallScreen: boolean;
    copyURLData?: any;
}

export class LeftMenuPartTemplate extends PureComponent<ILeftMenuPartTemplateProps, ILeftMenuPartTemplateStatus> {
    public floatLeftPartMenu: any;
    public floatMenuPane: any;
    public floatMenuContentElHeight: any;
    public CONTROL_BOX_LABELS: any;
    public CONTROL_BOX_TOC: any;
    public CONTROL_BOX_INFO: any;
    public CONTROL_BOX_PRINT: any;
    public CONTROL_BOX_SHARE: any;
    public ref_scrollbars: any;
    public startScrollTop = -1;

    constructor(props: ILeftMenuPartTemplateProps) {
        super(props);
        this.CONTROL_BOX_LABELS = React.createRef();
        this.CONTROL_BOX_TOC = React.createRef();
        this.CONTROL_BOX_INFO = React.createRef();
        this.CONTROL_BOX_PRINT = React.createRef();
        this.CONTROL_BOX_SHARE = React.createRef();
        this.ref_scrollbars = React.createRef();
        this.floatLeftPartMenu = null;
        this.floatMenuPane = null;
        this.floatMenuContentElHeight = null;
        this.state = {
            loadBackTab: false,
            loadTOCPart: false,
            loadTags: false,
            loadCopyURL: false,
            loadPrintTab: false,
            loadMoreTab: false,
            isSmallScreen: false
        };
        const isCvFrameMapping  = window.HTML_RENDITION.initialData.cvFrameWrapping === "true";
        if (!window.HTML_RENDITION.initialData.isStaticHtmlExport && !window.HTML_RENDITION.initialData.isStaticHtml){
            let currentUrl: string = window.location.href;
            if (!this.isExistingCopyURLData(currentUrl)) {
                window.HTML_RENDITION.initialData.finalCopyUrl.clear(); 
                !isStaticMode() && (this.props.loadCvrCopyURLData(getURLData('copyLHS')));
            } else {
                this.state = {
                    ...this.state,
                    copyURLData: this.getCopyURLData(currentUrl) 
                }
            }         
        }
        this.resetMenuHeight = this.resetMenuHeight.bind(this);
        this.handlePresentationSelectedThumbnailMenu = this.handlePresentationSelectedThumbnailMenu.bind(this);
    }

    public handlePresentationSelectedThumbnailMenu() {
        const selectedSlideIndex = commonStore.getState().presentationStateReducer.currentSlideIndex;
        this.ref_scrollbars.current.scrollTop(selectedSlideIndex * 112); // 112 is the margin-top plus thumbnail image height.
        this.loadImg();
        $('#carousel_vertical li').removeClass('selected');
        $('#carousel_vertical li').eq(selectedSlideIndex).addClass('selected');
    }

    public checkCurrentCompoentDOMEntit() {
        if (this.props.initialData) {
            this.CONTROL_BOX_LABELS.current && checkDomEntitlement(this.CONTROL_BOX_LABELS.current);
            this.CONTROL_BOX_TOC.current && checkDomEntitlement(this.CONTROL_BOX_TOC.current);
            this.CONTROL_BOX_INFO.current && checkDomEntitlement(this.CONTROL_BOX_INFO.current);
            this.CONTROL_BOX_PRINT.current && checkDomEntitlement(this.CONTROL_BOX_PRINT.current);
            this.CONTROL_BOX_SHARE.current && checkDomEntitlement(this.CONTROL_BOX_SHARE.current);
        }
    }

    public componentDidMount() {
        let currentUrl: string = window.location.href;        
        if (this.props.copyURLData && this.props.copyURLData.copyURL && !isNull(this.props.copyURLData.copyURL) ) {
            if (this.isExistingCopyURLData(currentUrl)) {
                let copyURLData: any = this.getCopyURLData(currentUrl);
                if (copyURLData.copyURL !== this.props.copyURLData.copyURL) {
                    this.setCopyURLData(currentUrl);
                }
            } else {
                this.setCopyURLData(currentUrl);
            }          
        }
        this.checkCurrentCompoentDOMEntit();
        this.floatLeftPartMenu = $("#floatLeftPartMenu");
        this.floatMenuPane = $("#floatMenuPane");
        this.floatMenuContentElHeight = this.floatLeftPartMenu.outerHeight();
        if (this.props.showOldBranding) {
            this.executeOldFunction()
        }
    }

    public componentDidUpdate(prevProps: any, prevState: any) {
        if (((prevProps.copyURLData && !prevProps.copyURLData.copyURL && this.props.copyURLData && this.props.copyURLData.copyURL) || 
               (prevProps.copyURLData && prevProps.copyURLData.copyURL && this.props.copyURLData && this.props.copyURLData.copyURL && 
                prevProps.copyURLData.copyURL.trim() !== this.props.copyURLData.copyURL.trim())) && !isNull(this.props.copyURLData.copyURL)) {           
            let currentUrl: string = window.location.href;
            this.setCopyURLData(currentUrl);
        }
    }

    private isExistingCopyURLData(currentUrl: string): boolean {        
        let copyURLData: any = window.HTML_RENDITION.initialData.finalCopyUrl.get(currentUrl);
        let isExisting = false;
        if (copyURLData) {
            isExisting = true;
        }
        return isExisting;
    }

    private getCopyURLData(currentUrl: string): string | undefined {        
        let copyURLData: any = window.HTML_RENDITION.initialData.finalCopyUrl.get(currentUrl);
        return copyURLData;
    }

    private setCopyURLData(currentUrl: string) {
        window.HTML_RENDITION.initialData.finalCopyUrl.set(currentUrl, this.props.copyURLData);
    }

    public executeOldFunction() {
        this.resetTop();
        $(window).on('resize', () => {
            this.resetTop();
        });
        this.floatMenuPane.find('.leftMenuList:visible:last').css("border", "1px solid #53565a");
        // After know why need FPFigureGalleryData you can open below code
        // this.props.loadFPFigureGalleryData();
    }

    public resetTop() {
        let top = 0;
        const windowHeight: any = $(window).height();
        const calculatedTop = (windowHeight - this.floatMenuContentElHeight) / 2;
        top = Math.max(0, calculatedTop);
        this.floatMenuPane.css({ "top": top });
    }

    public resetMenuHeight() {
        setTimeout(() => {
            if (window.innerWidth < 1200 || document.documentElement.clientHeight < 450) {
                this.setState({
                    isSmallScreen: true
                });
            } else {
                this.setState({
                    isSmallScreen: false
                });
            }
        }, 100);
    }

    public clickBackEvent() {
        RSCH_HTML_TRACKING_CONFIG.trackLeftMenuBackButtonClick();
        switchPage('backToMainPage');
    }

    public enterPressedLeftNavItem(e: any) {
        const code = e.keyCode || e.which;
        if (code === 13 || code === 32) {
            const currentMenuItem = $(e.currentTarget);
            if (this.checkEnterEventFromLeftMenuPaneContent(e) ) {
                setTimeout(() => {
                    currentMenuItem.removeClass('hover');
                    currentMenuItem.removeClass('open');
                    currentMenuItem.attr('aria-expanded', 'false');
                }, 10);
            } else if (e.target.id !== 'search_box_input') {
                this.leftMenuPaneEvent(e);
                currentMenuItem.focus();
            }
            if (e.currentTarget.id == 'leftMenuCitiBackTabLi') {
                this.clickBackEvent();
            }
        }
    }

    public leftMenuPaneKeyDownEvent(e: any) {
        const code = e.keyCode || e.which;
        if (code === 27) {
            const currentMenuItem = $(e.currentTarget);
            currentMenuItem.removeClass('hover open').focus();
        }
    }

    public checkEnterEventFromLeftMenuPaneContent(e: any) {
        const code = e.keyCode || e.which;
        if (code != 13) {
            return false;
        }

        const targetEle = $(e.target);
        const currentTargetEle = $(e.currentTarget);

        // check enter from TOC link in TOC content
        if ( !_.isEmpty(currentTargetEle.attr('id')) && currentTargetEle.attr('id')  === 'leftMenuTocTabLi') {
            if ( _.isEmpty(targetEle.attr('id')) || !_.isEmpty(targetEle.attr('id')) &&  targetEle.attr('id') != 'leftMenuTocTabLi' ) {
                if ($(targetEle).is('a') && !_.isEmpty($(targetEle).attr('data-scroll-to'))
                        && $(targetEle).hasClass('toc') && $(targetEle).hasClass('x-rsch-hyperlink')
                        ) {
                    return true;
                }
            }
        }

        return false;
    }

    public leftMenuPaneMouseLeaveEvent(e: any){
        if (e.currentTarget && e.currentTarget.classList && e.currentTarget.id) {
            const id = '#' + e.currentTarget.id;
            setTimeout(() => {
                const hasFocus = !! ($(id).find(':focus').length > 0);
                if (! hasFocus) {
                    $(id).removeClass('hover');
                    $(id).removeClass('open');
                }
            }, 10);
        }
    }

    public leftMenuPaneBlurEvent(e: any){
        if (e.currentTarget && e.currentTarget.classList && e.currentTarget.id) {
            const id = '#' + e.currentTarget.id;
            setTimeout(() => {
                if (id && id.length > 0) {
                    const hasFocus = !! ($(id).find(':focus').length > 0);
                    if (! hasFocus) {
                        $(id).removeClass('hover');
                        $(id).removeClass('open');
                    }
                }
            }, 10);
        }
    }

    public leftMenuPaneFocusEvent(e: any) {
        if (e.currentTarget && e.currentTarget.classList && e.currentTarget.id) {
            const id = '#' + e.currentTarget.id;
            setTimeout(() => {
                if (id && id.length > 0) {
                    const hasFocus = !! ($(id).find(':focus').length > 0);
                    if (! hasFocus) {
                        $('#floatMenuPane ul > li.leftMenuList > a[aria-expanded=true]').attr('aria-expanded', 'false');
                        $(id).attr('aria-expanded', 'true').parent('li').addClass('open');
                    }
                }
            }, 10);
        }
        this.leftMenuPaneEvent(e);
    }

    public leftMenuPaneEvent(e: any) {
        e.stopPropagation();
        if (e.target.classList.contains('leftMenuBtn') || e.target.classList.contains('leftMenuList')) {
            $(e.currentTarget).addClass('hover').siblings().removeClass('hover');
        }

        if (e.target.getAttribute('id') == 'citiBackTabButton' || e.target.getAttribute('id') == 'leftMenuCitiBackTabLi' || e.target.parentElement.id == 'leftMenuCitiBackTabLiID') {
            this.setState({
                loadBackTab: true
            });
        }
        if ((e.target.getAttribute('id') == 'tocTabButton' || e.target.getAttribute('id') == 'leftMenuTocTabLi') && HTML_RENDITION.isPresentation()) {
            this.handlePresentationSelectedThumbnailMenu();
        }
        if ((e.target.getAttribute('id') == 'tocTabButton' || e.target.getAttribute('id') == 'leftMenuTocTabLi') && !this.state.loadTOCPart) {
            this.setState({
                loadTOCPart: true
            });
        }
        else if ((e.target.getAttribute('id') == 'tagsTabButton' || e.target.getAttribute('id') == 'leftMenuTagsTabLi') && !this.state.loadTags) {
            RSCH_HTML_TRACKING_CONFIG.trackLeftMenuTagsClick();
            this.setState({
                loadTags: true
            });
        }
        else if ((e.target.getAttribute('id') == 'copyUrlTabButton' || e.target.getAttribute('id') == 'leftMenuCopyTabLi') && !this.state.loadCopyURL) {
           this.setState({
                loadCopyURL: true
            });
        }
        else if ((e.target.getAttribute('id') == 'printTabButton' || e.target.getAttribute('id') == 'leftMenuPrintTabLi') && !this.state.loadPrintTab) {
            RSCH_HTML_TRACKING_CONFIG.trackLeftMenuPrintClick(this.props.docHeaderSectionJson.metadata.ticker);
            this.setState({
                loadPrintTab: true
            });
        }
        else if ((e.target.getAttribute('id') == 'moreTabButton' || e.target.getAttribute('id') == 'leftMenuMoreTabLi') && !this.state.loadMoreTab) {
            RSCH_HTML_TRACKING_CONFIG.trackLeftMenuMoreTabClick();
            this.setState({
                loadMoreTab: true
            });
        }
    }

    public presentationCarouselMenu(e: any, index: number) {
        if ($('#mainPage').css('display') == 'none') {
            return;
        }
        e.stopPropagation();
        $('#carousel_vertical li').removeClass('selected');
        $('#carousel_vertical li').eq(index).addClass('selected');
        $('.nav_box').val(index + 1).trigger('change');
    }

    public handleScrollImgLazyLoading(e: any) {
        if (this.startScrollTop === -1) {
            this.startScrollTop = this.ref_scrollbars.current.view.scrollTop;
        }

        if (Math.abs(this.startScrollTop - this.ref_scrollbars.current.view.scrollTop) > 50) {
            this.startScrollTop = -1;
            this.loadImg();
        }
    }

    public loadImg(){
        const imgSet = $(this.ref_scrollbars.current.view).find('img');
        _.forEach(imgSet, (img) => {
            const $img = $(img);
            const domRect = img.getBoundingClientRect();
            // load the image if it is in the view port and has not yet been loaded
            if (domRect.top > 0 && domRect.top < 800 && !$img.hasClass('loaded')) {
                const src = $img.attr('data-src') || '';
                $img.attr('src', src).addClass('loaded');
            }
        });
    }

    public tocTplDom() {
        const tocTpl: any = [];
        if (HTML_RENDITION.isCompendiumProduct() || (window.HTML_RENDITION.initialData.isNewOutput && this.props.initialData.docFileType == 'HTML')) {
            tocTpl.push('');
        }
        else if (HTML_RENDITION.isPresentation() && this.props.initialData.productType != 'audio') {
            const slideThumbnailArr = this.props.docHeaderSectionJson.slide.thumbnails;
            tocTpl.push(
            <li ref={this.CONTROL_BOX_TOC}
                data-entitlement="CONTROL_BOX_TOC"
                id="leftMenuTocTabLi" key={2}
                onClick={(e) => this.leftMenuPaneEvent(e)}
                onMouseEnter={(e) => this.leftMenuPaneEvent(e)}
                onMouseLeave={(e) => this.leftMenuPaneMouseLeaveEvent(e)}
                onKeyPress={(e: any) => this.enterPressedLeftNavItem(e)}
                onBlur={(e) => this.leftMenuPaneBlurEvent(e)}
                onKeyDown={(e) => this.leftMenuPaneKeyDownEvent(e)}
                className='leftMenuList'
                tabIndex={0}
            >
                <a aria-expanded="false" role="link" id="tocTabButton" onFocus={(e) => {
                    RSCH_HTML_TRACKING_CONFIG.trackLeftMenuHover()
                    this.leftMenuPaneFocusEvent(e)
                }} className='leftMenuBtn' aria-label="Table of Contents"></a>
                <span id="mobile-tocTabButton"></span>
                <div onFocus={(e) => this.leftMenuPaneFocusEvent(e)}
                     className="carousel_menu menu-common menu-contents tagsPane animate-element" id="redesign_menu_content" style={{display: 'block', ...this.props.showOldBranding?{}:{left: '12px'}}}>
                     <div id="carousel_content" role="navigation" className="menu-common-width">
                        <Scrollbars onScroll={(e) => this.handleScrollImgLazyLoading(e)} ref={this.ref_scrollbars}
                                    style={{ width: '186px', height: this.state.isSmallScreen ? '41.5vh' : '400px' }}
                                    hideTracksWhenNotNeeded={true}
                        >
                            <div id="carousel_vertical">
                                <ul>
                                    {
                                        slideThumbnailArr.map((thumbnailImg: string, idx: number) => {
                                            const staticUrl = getContextPath('html') + '/';
                                            const thumbnailPath = staticUrl + slideThumbnailArr[idx];
                                            const currentSelectedSlideIndex = commonStore.getState().presentationStateReducer.currentSlideIndex;
                                            return (<li className={`li${idx} ${ idx == currentSelectedSlideIndex ? 'selected' : ''}`} data-number={idx} key={idx} tabIndex={0}
                                                            onKeyPress={(e) => enterKeyPressed(e, this.presentationCarouselMenu.bind(this, e, idx))}
                                                            onClick={(e) => this.presentationCarouselMenu(e, idx)}>
                                                        <span className="img-div">
                                                            <img className="carousel_thumb" alt='carousel thumbnail image' data-src={thumbnailPath} src={defaultImg} height="102" width="136"/>
                                                        </span>
                                                    </li>);
                                        })
                                    }
                                </ul>
                            </div>
                        </Scrollbars>
                    </div>
                </div>
            </li >);
        }
        else if (this.props.initialData.productType != 'audio' && this.props.initialData.productType != 'video') {
            tocTpl.push(
            <li ref={this.CONTROL_BOX_TOC}
                data-entitlement="CONTROL_BOX_TOC"
                id="leftMenuTocTabLi" key={3}
                onClick={(e) => this.leftMenuPaneEvent(e)}
                onMouseEnter={(e) => this.leftMenuPaneEvent(e)}
                onMouseLeave={(e) => this.leftMenuPaneMouseLeaveEvent(e)}
                onKeyPress={(e: any) => this.enterPressedLeftNavItem(e)}
                onBlur={(e) => this.leftMenuPaneBlurEvent(e)}
                onKeyDown={(e) => this.leftMenuPaneKeyDownEvent(e)}
                className='leftMenuList'
                tabIndex={0}
            >
                <a aria-expanded="false" role="link" id="tocTabButton" onFocus={(e) => this.leftMenuPaneFocusEvent(e)} className='leftMenuBtn' aria-label="Table of Contents"></a>
                <span id="mobile-tocTabButton"></span>
                <div onFocus={(e) => this.leftMenuPaneFocusEvent(e)} className="menu-common menu-contents tocPane animate-element" id="redesign_menu_content">
                    <div className="menu-common-width">
                        <Scrollbars style={{ width: '285px', height: this.state.isSmallScreen ? '49vh' : '350px' }}
                            renderThumbVertical={(props) => <div {...props} className="scroll-vertical" />}
                            onUpdate={this.resetMenuHeight}
                            hideTracksWhenNotNeeded={true}
                        >
                            {this.state.loadTOCPart && <TOCContainer />}
                        </Scrollbars>
                    </div>
                </div>
            </li >);
        }
        return tocTpl;
    }

    public render() {
        const { docHeaderSectionJson } = this.props;
        const showLHS = !window.HTML_RENDITION.initialData.isStaticHtmlExport && !window.HTML_RENDITION.initialData.isStaticHtml;
        const collapsedFloatMenuClass = this.props.collapsed ? "float-left-menu-collapsed" : "";
        const _pageName = commonStore.getState().commonStateReducer.switchPageData.pageName;
        
        return (
            <div role="region" id="floatMenuPane" className={isCitiExpress() ? `citi-express-float-menu ${collapsedFloatMenuClass}`: collapsedFloatMenuClass} aria-label="left menu pane">
                <div className="row menuPaneCustomRow">
                    <div aria-label="Page" role="navigation" className="menu-holder" id="floatLeftPartMenu">
                        {UserAgentUtils.isMobile.any() && <div id="mobile-leftMenuCitiVelocityTab"></div>}
                        {!UserAgentUtils.isMobile.any() && <div id="web-leftMenuCitiVelocityTab"></div>}
                        <ul className="nav custom-tabs">
                        <li style={{ display: `${this.props.showOldBranding ? 'none' : _pageName !== 'mainPage' ? 'block' : 'none' }` }}
                                id="leftMenuCitiBackTabLi"
                                onClick={() => this.clickBackEvent()}
                                onMouseEnter={(e) => this.leftMenuPaneEvent(e)}
                                onMouseLeave={(e) => this.leftMenuPaneMouseLeaveEvent(e)}
                                onKeyPress={(e: any) => this.enterPressedLeftNavItem(e)}
                                onBlur={(e) => this.leftMenuPaneBlurEvent(e)}
                                onKeyDown={(e) => this.leftMenuPaneKeyDownEvent(e)}
                                className='leftMenuList'
                                tabIndex={0}
                            >
                                <a id="citiBackTabButton" role="link"  aria-label={docHeaderSectionJson.i18n.floatMenuTooltip_Back} onFocus={(e) => this.leftMenuPaneFocusEvent(e)} className='leftMenuBtn'></a>
                                <div className={(docHeaderSectionJson.i18n.floatMenuTooltip_Back ? '' : 'hide ') + "menu-tooltip citiBackPane animate-element"} id="leftMenuCitiBackTabLiID">
                                    <div className="menu-tooltip-width">
                                        {docHeaderSectionJson.i18n.floatMenuTooltip_Back}
                                    </div>
                                </div>
                            </li>
                            {this.props.showOldBranding && showLHS && this.tocTplDom()}
                            {showLHS &&
                                MENU_CHECK.showTags(this.props.docHeaderSectionJson.issuerPage) &&
                                (
                                    <li ref={this.CONTROL_BOX_LABELS}
                                        data-entitlement="CONTROL_BOX_LABELS"
                                        id="leftMenuTagsTabLi"
                                        onClick={(e) => this.leftMenuPaneEvent(e)}
                                        onMouseEnter={(e) => this.leftMenuPaneEvent(e)}
                                        onMouseLeave={(e) => this.leftMenuPaneMouseLeaveEvent(e)}
                                        onKeyPress={(e: any) => this.enterPressedLeftNavItem(e)}
                                        onBlur={(e) => this.leftMenuPaneBlurEvent(e)}
                                        onKeyDown={(e) => this.leftMenuPaneKeyDownEvent(e)}
                                        className='leftMenuList'
                                        tabIndex={0}
                                    >
                                        <a aria-expanded="false" id="tagsTabButton" role="link" onFocus={(e) => this.leftMenuPaneFocusEvent(e)} className='leftMenuBtn' aria-label="Tags"></a>
                                        <div onFocus={(e) => this.leftMenuPaneFocusEvent(e)} className="menu-common menu-tags tagsPane animate-element">
                                            <div className="menu-common-width">
                                                <Scrollbars style={{ width: '285px', height: this.state.isSmallScreen ? '41.5vh' : '400px'  }}
                                                            renderThumbVertical={(props) => <div {...props} className="scroll-vertical" />}
                                                            onUpdate={this.resetMenuHeight}
                                                            hideTracksWhenNotNeeded={true}
                                                >
                                                    {this.state.loadTags && <TagsContainer />}
                                                </Scrollbars>
                                            </div>
                                        </div>
                                    </li>
                                )
                            }
                            {showLHS &&
                                MENU_CHECK.showFloatMenuCopy(this.props.initialData.urlParameters.preview_mode) &&
                                <li ref={this.CONTROL_BOX_INFO}
                                    data-entitlement="CONTROL_BOX_INFO"
                                    id="leftMenuCopyTabLi"
                                    onClick={(e) => this.leftMenuPaneEvent(e)}
                                    onMouseEnter={(e) => this.leftMenuPaneEvent(e)}
                                    onMouseLeave={(e) => this.leftMenuPaneMouseLeaveEvent(e)}
                                    onKeyPress={(e: any) => this.enterPressedLeftNavItem(e)}
                                    onBlur={(e) => this.leftMenuPaneBlurEvent(e)}
                                    onKeyDown={(e) => this.leftMenuPaneKeyDownEvent(e)}
                                    className='leftMenuList'
                                    tabIndex={0}
                                >
                                    <a aria-expanded="false" id="copyUrlTabButton" role="link" onFocus={(e) => this.leftMenuPaneFocusEvent(e)} className='leftMenuBtn' aria-label="Copy URL"></a>
                                    <div onFocus={(e) => this.leftMenuPaneFocusEvent(e)} className="menu-common menu-copy CopyURLPane animate-element">
                                        <div className="menu-common-width">
                                            <Scrollbars style={{ width: '285px', height: '260px' }}
                                                        renderThumbVertical={(props) => <div {...props} className="scroll-vertical" />}
                                                        hideTracksWhenNotNeeded={true}
                                            >
                                                {this.state.loadCopyURL && <CopyURLContainer source={this.props.copyURLData || this.state.copyURLData} />}
                                            </Scrollbars>
                                        </div>
                                    </div>
                                </li>
                            }
                            {showLHS &&
                                MENU_CHECK.showPrint(this.props.docHeaderSectionJson.issuerPage) &&
                                (
                                    <li ref={this.CONTROL_BOX_PRINT}
                                        data-entitlement="CONTROL_BOX_PRINT"
                                        id="leftMenuPrintTabLi"
                                        onClick={(e) => this.leftMenuPaneEvent(e)}
                                        onMouseEnter={(e) => this.leftMenuPaneEvent(e)}
                                        onMouseLeave={(e) => this.leftMenuPaneMouseLeaveEvent(e)}
                                        onKeyPress={(e: any) => this.enterPressedLeftNavItem(e)}
                                        onBlur={(e) => this.leftMenuPaneBlurEvent(e)}
                                        onKeyDown={(e) => this.leftMenuPaneKeyDownEvent(e)}
                                        className='leftMenuList'
                                        tabIndex={0}
                                    >
                                        <a aria-expanded="false" id="printTabButton" role="link" onFocus={(e) => this.leftMenuPaneFocusEvent(e)} className='leftMenuBtn' aria-label="Print"></a>
                                        <div onFocus={(e) => this.leftMenuPaneFocusEvent(e)} className="menu-common menu-print printPane animate-element">
                                            <div className="menu-print-width">
                                                <div id="printPDF">
                                                    {this.state.loadPrintTab && <PrintTabContainer docTitle={this.props.docTitle} />}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                )
                            }

                            {showLHS &&
                            <li ref={this.CONTROL_BOX_SHARE}
                                data-entitlement="CONTROL_BOX_SHARE"
                                id="leftMenuMoreTabLi"
                                onClick={(e) => this.leftMenuPaneEvent(e)}
                                onMouseEnter={(e) => this.leftMenuPaneEvent(e)}
                                onMouseLeave={(e) => this.leftMenuPaneMouseLeaveEvent(e)}
                                onKeyPress={(e: any) => this.enterPressedLeftNavItem(e)}
                                onBlur={(e) => this.leftMenuPaneBlurEvent(e)}
                                onKeyDown={(e) => this.leftMenuPaneKeyDownEvent(e)}
                                className='leftMenuList'
                                tabIndex={0}
                            >
                                <a aria-expanded="false" id="moreTabButton" role="link" onFocus={(e) => this.leftMenuPaneFocusEvent(e)} className='leftMenuBtn' aria-label="Share Tab"></a>
                                <div onFocus={(e) => this.leftMenuPaneFocusEvent(e)} className="menu-common menu-more shareTabPane animate-element">
                                    <Scrollbars style={{ width: '285px', height: this.state.isSmallScreen ? '45vh' : '360px' }}
                                                renderThumbVertical={(props) => <div {...props} className="scroll-vertical" />}
                                                onUpdate={this.resetMenuHeight} hideTracksWhenNotNeeded={true}
                                    >
                                        {this.state.loadMoreTab && <MoreContainer />}
                                    </Scrollbars>
                                </div>
                            </li>
                            }
                            {!this.props.showOldBranding && showLHS && this.tocTplDom()}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        copyURLData: state.asyncStateReducer.copyURLData,
        collapsed: state.commonStateReducer.collapsed,
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    loadCvrCopyURLData: (copyURL: string) => dispatch(fetchCvrCopyURL(Object.assign(servicesConfig.GET_CVR_URL, { 'url_parameter': ['url=' + encodeURIComponent(copyURL)] }))),
    loadCopyURLData: (copyURL: string) => dispatch(fetchCopyURL(Object.assign(servicesConfig.GET_COPY_URL, { 'url_parameter': ['copyURL=' + encodeURIComponent(copyURL)] }))),
    loadPublicCopyURLData: (copyURL: string) => dispatch(fetchCopyURL(Object.assign(servicesConfig.GET_PUBLIC_COPY_URL, { 'url_parameter': ['copyURL=' + encodeURIComponent(copyURL)] }))),
    loadFPFigureGalleryData: () => dispatch(fetchFPFigureGallery(environmentService.getJsonPath(servicesConfig.GET_FP_FIGURE_GALLERY))),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeftMenuPartTemplate);
